//在线维修
import { httpRequest } from '../request';

//Dms国家省市接口
interface IGetCountryList {
  type: number;
  code?: string;
}
export function getCountryList(data: IGetCountryList) {
  return httpRequest({
    url: 'self-service/getDmsCode',
    data
  });
}

interface IRepairOnline {}
export function repairOnline(data: IRepairOnline) {
  return httpRequest({
    url: 'self-service/incident/repair-case',
    data,
    method: 'post'
  });
}

//获取产品系列
interface IGetProductSeries {}
export function getProductSeries(data) {
  return httpRequest({
    url: 'product/category/tree/two-three',
    data
  });
}

interface IGetCategory {}
export function getCategory(data) {
  return httpRequest({
    url: 'product/common/list',
    data
  });
}

// aws-预签名
export function getPreUrl(data: any) {
  return httpRequest({
    url: 'v2/common/upload',
    // baseURL: 'https://cn-dev-oms-gateway.segwaydiscovery.com/',
    data
  });
}

export function deviceRecall(data: IRepairOnline) {
  return httpRequest({
    url: '/self-service/device/recall',
    data,
    method: 'post'
  });
}

export function getProductModelList() {
  return httpRequest({
    url: '/self-service/device/recall/list',
    method: 'get'
  });
}
